// GÉNÉRÉ par scripts/set-native-env.mjs — NE PAS éditer à la main.
export const NATIVE_ENV: string = 'dev';
